<link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />

<app-header-nav-bar>
    <app-header-nav-text></app-header-nav-text>
    <app-header-home [moduleName]="'snapshot'"></app-header-home>
</app-header-nav-bar>

<div class="preview_container">
    <div class="preeview_left_container">
        <div class="preview_header">
            <img class="back-btn" (click)="goback()" alt="backbutton"
                src="../../../../assets/ImagesSnapshot/Public/Back_icon.svg">
            <div class="header_text">Snapshot preview</div>
        </div>
        <div style="margin-top:1rem;">
            <div style="display:flex;">
                <p>PAGE {{pageCount}}</p>
                <!-- <div  class="layoutDropdownContent">
                    <span class="layoutLabel">Snapshot Layout</span>
                    <div class="layoutDropdown" (click)="onLayoutClick()">
                        <span>{{displayLayout}}</span>
                        <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="layoutArrowIcon">
                    </div>
                    <div *ngIf="openLayoutDropdown" class="a">
                        <div *ngFor="let value of layoutValues">
                            <div class="valueData" title="{{value.name}}" (click)="layoutClicked(value)"
                            [ngClass]="{'selected-item': displayLayout === value.key}"
                            >{{value.key}}</div>
                        </div>
                    </div>
                </div> -->
            </div>


            <hr style="border-color: #8600CD;border-top-width: 0;margin-top:0.3%">
        </div>

        <div class="preview_body" style="display:flex; justify-content:center;">
            <div class="grid-container" style="width:95%; " #gridContainer
                [style.grid-template-columns]="gridTempleteColumns" [ngStyle]="{ 'display': data.length == 1 ? 'flex' : 'grid' }">
                <!-- <div class="grid-container" #gridContainer [style.grid-template-columns]="'27.5rem 27.5rem'"> -->
                <div class="grid_item" [attr.grid_index]="i" [attr.page_index]="pageCount" id="grid_item_{{i}}"
                    *ngFor="let item of data;index as i" [ngClass]="{'grid_item1':data.length == 1}" [ngStyle]="{ 'max-height': data.length == 1 ? '26rem' : '13rem' }">
                    <div class="no_chart_selection" [attr.grid_index]="i" [attr.page_index]="pageCount"
                        *ngIf="isChartDragged(item)">
                        <div class="add_icon" [attr.grid_index]="i" [attr.page_index]="pageCount"></div>
                        <div class="text" [attr.grid_index]="i" [attr.page_index]="pageCount">Drag & Drop the Widget
                        </div>
                    </div>
                    <div class="widget_draw_container" *ngIf="!isChartDragged(item)">
                        <div class="widget_draw_header">
                            <div class="header_text">{{getWidgetName(item)}}</div>
                            <div class="close_icon" (click)="removeWidgetFromGrid(item)"></div>
                        </div>
                        <div class="widget_draw_body" [ngStyle]="{ 'height': data.length == 1 ? '90%' : '80%' }">
                            <div class="widget_image_div">
                                <img class="widget_image" [src]=getWidgetImage(item)>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div style="height:100%;width:5%;">
                <div style="position:relative;top:33.5%;left:25%;">
                    <div class="leftPageDiv" (click)="Paginate('left')" [ngClass]="{'disabled':disableLeftClick}">
                        <span class="material-symbols-outlined leftPageClick">arrow_circle_left</span>
                    </div>
                    <div class="rightPageDiv" (click)="Paginate('right')" [ngClass]="{'disabled':disableRightClick}">
                        <span class="material-symbols-outlined rightPageClick">arrow_circle_right</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="preview_submit">
            <!-- <div class="btn-container" style="display:none">
                <div class="button-img save"></div>
                <div class="btn-text">Save</div>
            </div> -->
            <div class="btn-container" (click)="SubmitClicked()"
                [ngClass]="{'matched': ifCountMatched, 'disabled': !ifCountMatched}">
                <div class="button-img submit"></div>
                <div class="btn-text">Submit</div>
            </div>

        </div>
    </div>
    <div class="preeview_right_container">
        <app-visual-select [disabledrag]="false" [maxheightofbody]="'27rem'" [widgetList]="widgetList" (triggerDrop)="drop($event)"
            (newWidgetList)="newListfromVisualSelect($event)" [deleteFlag]="true"></app-visual-select>

    </div>

</div>

<app-shared-popup-snapshot *ngIf="showBackPopUp" [reference]="showBackPopUp" [errorheaderTitle]="backButtonTitle"
    [popUpMessage]="backButtonMessage" (closeErrorPopUp)="onCloseIconClick($event)"
    (closeConfirmationPopUp)="onProceedClick($event)" [showConfirmationPopUp]="confirmationPopup"
    [showInputPopUp]="!confirmationPopup" [popUpParameter]="'Confirmation'"
    [showErrorPopUp]="!confirmationPopup"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [showErrorPopUp]="showErrorPopUp" [showInputPopUp]="false" [showConfirmationPopUp]="false" [errorheaderTitle]="errorheaderTitle" [popUpMessage]="popUpMessage"
    (closeErrorPopUp)="onCloseIconClickk($event)"></app-shared-popup-snapshot>